function sortfuntion() {
  setTimeout(function () {
    var url_sort = document.querySelector('[name="sort_by"]');
    (url_sort = url_sort.value),
      (window.location.href =
        document.querySelector('[rel="canonical"]').getAttribute("href") +
        "?sort_by=" +
        url_sort);
  }, 300);
}
(window.theme = window.theme || {}), (window.Shopify = window.Shopify || {});
class LocalizationForm extends HTMLElement {
  constructor() {
    super(),
      (this.elements = {
        input: this.querySelector(
          'input[name="language_code"], input[name="country_code"]'
        ),
        button: this.querySelector("button"),
        panel: this.querySelector(".disclosure__modal"),
      }),
      this.elements.button.addEventListener(
        "click",
        this.openSelector.bind(this)
      ),
      this.elements.button.addEventListener(
        "focusout",
        this.closeSelector.bind(this)
      ),
      this.addEventListener("keyup", this.onContainerKeyUp.bind(this)),
      this.querySelectorAll("a").forEach((item) =>
        item.addEventListener("click", this.onItemClick.bind(this))
      );
  }
  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false"),
      this.elements.panel.setAttribute("hidden", !0);
  }
  onContainerKeyUp(event) {
    "ESCAPE" === event.code.toUpperCase() &&
      (this.hidePanel(), this.elements.button.focus());
  }
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    (this.elements.input.value = event.currentTarget.dataset.value),
      form && form.submit();
  }
  openSelector() {
    this.elements.button.focus(),
      this.elements.panel.toggleAttribute("hidden"),
      this.elements.button.setAttribute(
        "aria-expanded",
        (
          "false" === this.elements.button.getAttribute("aria-expanded")
        ).toString()
      );
  }
  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && "BUTTON" === event.relatedTarget.nodeName;
    (null === event.relatedTarget || shouldClose) && this.hidePanel();
  }
}
customElements.define("localization-form", LocalizationForm),
  $(document).on("click", ".grid-variant-input", function () {
    $(this)
      .parents(".card-details__wrapper")
      .find(".variant__label-info span")
      .text($(this).find("label").attr("value")),
      "true" == $(this).attr("data-sale")
        ? ($(this)
            .parents(".card-details__wrapper")
            .find(".price__sale")
            .show(),
          $(this)
            .parents(".card-details__wrapper")
            .find(".price__regular")
            .hide(),
          $(this)
            .parents(".card-details__wrapper")
            .find(".sale___price span.price-item.price-item--sale")
            .html($(this).attr("data-price")),
          $(this)
            .parents(".card-details__wrapper")
            .find(".price__compare span.price-item.price-item--regular")
            .html($(this).attr("data-compare-price")))
        : ($(this)
            .parents(".card-details__wrapper")
            .find(".price__sale")
            .hide(),
          $(this)
            .parents(".card-details__wrapper")
            .find(".price__regular")
            .show(),
          $(this)
            .parents(".card-details__wrapper")
            .find(".price__regular span.price-item.price-item--regular")
            .html($(this).attr("data-price")));
    var select_img = $(this).attr("image-src");
    $(this)
      .parents('.product__detail [data-type="add-to-cart-form"]')
      .find('[name="id"]')
      .attr("value", $(this).attr("option-id")),
      $(this)
        .parents(".collection-product-item")
        .find('[name="id"]')
        .attr("value", $(this).attr("option-id")),
      $(this)
        .parents(".card-wrapper")
        .find('input[name="id"]')
        .val($(this).attr("option-id")),
      $(this)
        .parents(".card-wrapper")
        .find('input[name="id"]')
        .attr("value", $(this).attr("option-id")),
      "undefined" != select_img &&
        "" != select_img &&
        $(this)
          .parents(".card-wrapper")
          .find(".card__inner .media img")
          .attr("src", select_img);
  }),
  $(document).on(
    "change",
    '.target-allproducts__main input[type="radio"]',
    function () {
      var parnt_first = $(this).parents(".option-swatch"),
        parnt_main = $(this).parents("fieldset.js.product-form__inpt");
      parnt_main
        .find(".variant__label-info span")
        .text(parnt_first.find("label").attr("value")),
        parnt_main.find("label").removeClass("selected"),
        parnt_first.find("label").addClass("selected");
    }
  ),
  $(document).on("click", ".card-wrapper .option-swatch", function () {
    "undefined" != $(this).attr("image-src") &&
      "" != $(this).attr("image-src") &&
      $(this)
        .parents(".card-wrapper")
        .find(".card__inner .media img")
        .attr("src", $(this).attr("image-src"));
  }),
  $(document).on("click", ".card-wrapper .card--product", function (t) {
    t.preventDefault(),
      $(t.target).hasClass("quick_view_btn") ||
        0 !== $(t.target).closest(".quick_view_btn").length ||
        ($(this).attr("data-href") &&
          (window.location.href = $(this).attr("data-href")));
  });
var popup = $(".size-chart-wrapper.popup-overlay");
popup[0].addEventListener("keyup", function (event) {
  "ESCAPE" === event.code.toUpperCase() &&
    $(".size-chart-wrapper.popup-overlay .close").click();
}),
  $(".size__chart-trigger").each(function (sizeChartTrigger) {
    fireClickOnEnterKeydown($(this)[0]);
  }),
  $(".size-chart-wrapper.popup-overlay .sizes-list li").each(function (
    sizeChartTrigger
  ) {
    fireClickOnEnterKeydown($(this)[0]);
  }),
  $(
    ".size-chart-wrapper.popup-overlay .chart-content_units li.units .btn"
  ).each(function (sizeChartTrigger) {
    fireClickOnEnterKeydown($(this)[0]);
  }),
  $(document).on("click", ".size__chart-trigger", function (e) {
    e.preventDefault,
      popup.length > 0 &&
        (popup.toggleClass("is-active"),
        trapFocus(
          document.querySelector(".size-chart-wrapper"),
          document.querySelector(".size-chart-wrapper .close")
        ));
  }),
  $(document).on("click", ".size-chart-wrapper.popup-overlay", function (e) {
    $(e.target).hasClass("popup-content") ||
      0 !== $(e.target).closest(".popup-content").length ||
      $(this).removeClass("is-active");
  }),
  $(document).on(
    "click",
    ".size-chart-wrapper.popup-overlay .close",
    function (e) {
      if (
        (e.preventDefault(),
        popup.removeClass("is-active"),
        document.querySelector("#quick-view.active_quickView"))
      ) {
        let removeFocusToElem = document.querySelector(
          "#quick-view .size__chart-trigger"
        );
        removeTrapFocus(removeFocusToElem);
      } else {
        let removeFocusToElem = document.querySelector(".size__chart-trigger");
        removeTrapFocus(removeFocusToElem);
      }
    }
  ),
  $(document).on(
    "click",
    ".size-chart-wrapper.popup-overlay .sizes-list li",
    function () {
      if (!$(this).hasClass("is-selected")) {
        popup.find(".sizes-list li.is-selected").removeClass("is-selected"),
          popup
            .find(".chart-content-wrapper.is-selected")
            .removeClass("is-selected"),
          $(this).addClass("is-selected");
        var size = $(this).attr("data-size");
        popup.find("[data-size-target=" + size + "]").addClass("is-selected");
      }
    }
  ),
  $(document).on(
    "click",
    ".size-chart-wrapper.popup-overlay .chart-content_units li.units .btn",
    function (e) {
      if (
        (e.preventDefault(),
        $(this).toggleClass("cm-selected"),
        $(this).hasClass("cm-selected"))
      )
        var unit = "cm";
      else unit = "in";
      popup.find(".chart-content-wrapper .unit-value").each(function () {
        $(this).hasClass(unit) ? $(this).show() : $(this).hide();
      }),
        popup.find("[data-size-target=" + size + "]").addClass("is-selected");
    }
  ),
  $(document).on(
    "click",
    ".quantity__main button.quantity_box",
    function (e) {
      e.preventDefault();
      var _ths = $(this),
        curnt_vlu = $(this)
          .parents(".quantity__main")
          .find(".quantity_box.quantity_num input")
          .val();
      if (
        ($(this).hasClass("quantity__increase")
          ? (curnt_vlu = parseFloat(curnt_vlu) + 1)
          : $(this).hasClass("quantity__decrease") &&
            curnt_vlu > 0 &&
            (curnt_vlu = parseFloat(curnt_vlu) - 1),
        $(this)
          .parents(".quantity__main")
          .find(".quantity_box.quantity_num input")
          .attr("value", curnt_vlu),
        $(this)
          .parents(".quantity__main")
          .find(".quantity_box.quantity_num input")
          .val(curnt_vlu),
        $(this)
          .parents(".product__detail")
          .find('form input[name="quantity"]')
          .val(curnt_vlu))
      ) {
        var vr_id = _ths
          .parents(".quantity__main")
          .find('[name="quantity"]')
          .attr("line-item-id");
        testQty(vr_id, curnt_vlu);
      }
    }
  ),
  $(document).on(
    "change",
    '.quantity__main [name="quantity"]',
    function (e) {
      e.preventDefault();
      var _ths = $(this),
        curnt_vlu = $(this)
          .parents(".quantity__main")
          .find(".quantity_box.quantity_num input")
          .val();
      if (
        ($(this)
          .parents(".quantity__main")
          .find(".quantity_box.quantity_num input")
          .attr("value", curnt_vlu),
        $(this)
          .parents(".quantity__main")
          .find(".quantity_box.quantity_num input")
          .val(curnt_vlu),
        $(this)
          .parents(".cart")
          .find('form input[name="quantity"]')
          .val(curnt_vlu))
      ) {
        var vr_id = _ths
          .parents(".quantity__main")
          .find('[name="quantity"]')
          .attr("line-item-id");
        testQty(vr_id, curnt_vlu);
      }
    }
  ),
  document.addEventListener("click", function (event) {
    if (!event.target.closest(".disclosure")) {
      document
        .querySelectorAll(".disclosure__modal")
        .forEach((modal) => modal.setAttribute("hidden", true));
    }
  }),
  $(document).on("click", ".quantity .quantity__button", function (e) {
    e.preventDefault();
    var curnt_vlu = $(this)
      .parents("[quantity-input]")
      .find('[name="quantity"]')
      .val();
    "plus" == $(this).attr("name")
      ? (curnt_vlu = parseFloat(curnt_vlu) + 1)
      : "minus" == $(this).attr("name") &&
        curnt_vlu > 1 &&
        (curnt_vlu = parseFloat(curnt_vlu) - 1),
      $(this)
        .parents("[quantity-input]")
        .find('[name="quantity"]')
        .attr("value", curnt_vlu),
      $(this)
        .parents("[quantity-input]")
        .find('[name="quantity"]')
        .val(curnt_vlu);
  }),
  $(document).on("click", ".mobile-filter-icon", function () {
    $(this).toggleClass("show_cross"),
      $("form.urge-filter").toggleClass("show_mobile"),
      $("body").toggleClass("drawer--open");
  }),
  $(document).on(
    "click",
    ".mobile_drawer_header .drawer_close_icon",
    function () {
      $(".mobile-filter-icon").removeClass("show_cross"),
        $("form.urge-filter").removeClass("show_mobile"),
        $("body").removeClass("drawer--open");
    }
  ),
  $(document).on("click", "body.drawer--open", function () {
    $(".mobile-filter-icon").removeClass("show_cross"),
      $("form.urge-filter").removeClass("show_mobile"),
      $("body").removeClass("drawer--open");
  }),
  $(document).on(
    "click",
    ".urge_covered_filters .filter-group-summary",
    function (e) {
      e.stopPropagation();
    }
  ),
  $(
    '.main__product [action="/cart/add"] [name="id"], .featured__product [action="/cart/add"] [name="id"]'
  ).change(function () {
    var id = $(this).val() ? $(this).val() : $(this).find(":selected").val(),
      target_media = $(this)
        .closest(".shopify-section")
        .find(
          '.product-galley---image[data-alt="variant=' +
            id +
            '"] .product__thumb'
        );
    target_media.length > 0 && target_media.trigger("click");
  }),
  (theme.config = {
    hasSessionStorage: !0,
    hasLocalStorage: !0,
    isTouch: !!(
      "ontouchstart" in window ||
      (window.DocumentTouch && window.document instanceof DocumentTouch) ||
      window.navigator.maxTouchPoints ||
      window.navigator.msMaxTouchPoints
    ),
    rtl: "rtl" == document.documentElement.getAttribute("dir"),
  }),
  (function () {
    "use strict";
    AOS.init({
      easing: "ease-out-quad",
      once: !0,
      offset: 60,
      disableMutationObserver: !0,
    }),
      (theme.delegate = {
        on: function (t, e, i) {
          return (
            this.namespaces || (this.namespaces = {}),
            (this.namespaces[t] = e),
            (i = i || !1),
            this.addEventListener(t.split(".")[0], e, i),
            this
          );
        },
        off: function (t) {
          if (this.namespaces)
            return (
              this.removeEventListener(t.split(".")[0], this.namespaces[t]),
              delete this.namespaces[t],
              this
            );
        },
      }),
      (theme.utils = {
        defaultTo: function (t, e) {
          return null == t || t != t ? e : t;
        },
        wrap: function (t, e) {
          t.parentNode.insertBefore(e, t), e.appendChild(t);
        },
        debounce: function (t, e, i) {
          var n;
          return function () {
            var s = this,
              o = arguments,
              a = function () {
                (n = null), i || e.apply(s, o);
              },
              l = i && !n;
            clearTimeout(n), (n = setTimeout(a, t)), l && e.apply(s, o);
          };
        },
        throttle: function (t, e) {
          var i = !1;
          return function () {
            i ||
              (e.apply(this, arguments),
              (i = !0),
              setTimeout(function () {
                i = !1;
              }, t));
          };
        },
        prepareTransition: function (t, e) {
          t.addEventListener("transitionend", function i(e) {
            t.classList.remove("is-transitioning"),
              t.removeEventListener("transitionend", i);
          }),
            t.classList.add("is-transitioning"),
            t.offsetWidth,
            "function" == typeof e && e();
        },
        compact: function (t) {
          for (
            var e = -1, i = null == t ? 0 : t.length, n = 0, s = [];
            ++e < i;

          ) {
            var o = t[e];
            o && (s[n++] = o);
          }
          return s;
        },
        serialize: function (t) {
          var e = [];
          return (
            Array.prototype.slice.call(t.elements).forEach(function (t) {
              !t.name ||
                t.disabled ||
                ["file", "reset", "submit", "button"].indexOf(t.type) > -1 ||
                ("select-multiple" !== t.type
                  ? (["checkbox", "radio"].indexOf(t.type) > -1 &&
                      !t.checked) ||
                    e.push(
                      encodeURIComponent(t.name) +
                        "=" +
                        encodeURIComponent(t.value)
                    )
                  : Array.prototype.slice.call(t.options).forEach(function (i) {
                      i.selected &&
                        e.push(
                          encodeURIComponent(t.name) +
                            "=" +
                            encodeURIComponent(i.value)
                        );
                    }));
            }),
            e.join("&")
          );
        },
      }),
      (theme.initWhenVisible = function (t) {
        var e = t.threshold ? t.threshold : 0,
          i = new IntersectionObserver(
            (e, i) => {
              e.forEach((e) => {
                e.isIntersecting &&
                  "function" == typeof t.callback &&
                  (t.callback(), i.unobserve(e.target));
              });
            },
            {
              rootMargin: "0px 0px " + e + "px 0px",
            }
          );
        i.observe(t.element);
      }),
      (window.on = Element.prototype.on = theme.delegate.on),
      (window.off = Element.prototype.off = theme.delegate.off),
      document.documentElement.on("keyup.tab", function (t) {
        9 === t.keyCode &&
          (document.documentElement.classList.add("tab-outline"),
          document.documentElement.off("keyup.tab"));
      }),
      (theme.Sections = function () {
        (this.constructors = {}),
          (this.instances = []),
          document.addEventListener(
            "shopify:section:load",
            this._onSectionLoad.bind(this)
          ),
          document.addEventListener(
            "shopify:section:unload",
            this._onSectionUnload.bind(this)
          ),
          document.addEventListener(
            "shopify:section:select",
            this._onSelect.bind(this)
          ),
          document.addEventListener(
            "shopify:section:deselect",
            this._onDeselect.bind(this)
          ),
          document.addEventListener(
            "shopify:block:select",
            this._onBlockSelect.bind(this)
          ),
          document.addEventListener(
            "shopify:block:deselect",
            this._onBlockDeselect.bind(this)
          );
      }),
      (theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
        _createInstance: function (t, e, i) {
          var n = t.getAttribute("data-section-id"),
            s = t.getAttribute("data-section-type");
          if (void 0 !== (e = e || this.constructors[s])) {
            if (i) this._findInstance(n) && this._removeInstance(n);
            var a = Object.assign(new e(t), {
              id: n,
              type: s,
              container: t,
            });
            this.instances.push(a);
          }
        },
        _findInstance: function (t) {
          for (var e = 0; e < this.instances.length; e++)
            if (this.instances[e].id === t) return this.instances[e];
        },
        _removeInstance: function (t) {
          for (var e, i = this.instances.length; i--; )
            if (this.instances[i].id === t) {
              (e = this.instances[i]), this.instances.splice(i, 1);
              break;
            }
          return e;
        },
        _onSectionLoad: function (t, e, i) {
          animateElements(),
          window.AOS && AOS.refreshHard(),
            theme && theme.initGlobals && theme.initGlobals();
          var n = e || t.target,
            s = e || t.target.querySelector("[data-section-id]");
          if (s) {
            this._createInstance(s);
            var o = e ? i : this._findInstance(t.detail.sectionId);
            n.querySelectorAll("[data-subsection]").length &&
              this.loadSubSections(n),
              o && "function" == typeof o.onLoad && o.onLoad(t),
              setTimeout(function () {
                window.dispatchEvent(new Event("scroll")),
                  window.dispatchEvent(new Event("resize"));
              }, 200);
          }
        },
        _onSectionUnload: function (t) {
          this.instances = this.instances.filter(function (e) {
            var i = e.id === t.detail.sectionId;
            return i && "function" == typeof e.onUnload && e.onUnload(t), !i;
          });
        },
        loadSubSections: function (t) {
          (t
            ? t.querySelectorAll("[data-subsection]")
            : document.querySelectorAll("[data-subsection]")
          ).forEach((t) => {
            this._onSectionLoad(null, t, t.dataset.sectionId);
          }),
            window.AOS && AOS.refreshHard();
        },
        _onSelect: function (t) {
          var e = this._findInstance(t.detail.sectionId);
          void 0 !== e && "function" == typeof e.onSelect && e.onSelect(t);
        },
        _onDeselect: function (t) {
          var e = this._findInstance(t.detail.sectionId);
          void 0 !== e && "function" == typeof e.onDeselect && e.onDeselect(t);
        },
        _onBlockSelect: function (t) {
          var e = this._findInstance(t.detail.sectionId);
          void 0 !== e &&
            "function" == typeof e.onBlockSelect &&
            e.onBlockSelect(t);
        },
        _onBlockDeselect: function (t) {
          var e = this._findInstance(t.detail.sectionId);
          void 0 !== e &&
            "function" == typeof e.onBlockDeselect &&
            e.onBlockDeselect(t);
        },
        register: function (t, e, i) {
          this.constructors[t] = e;
          var n = document.querySelectorAll('[data-section-type="' + t + '"]');
          i && (n = i.querySelectorAll('[data-section-type="' + t + '"]')),
            n.forEach(
              function (t) {
                this._createInstance(t, e, i);
              }.bind(this)
            );
        },
        reinit: function (t) {
          for (var e = 0; e < this.instances.length; e++) {
            var i = this.instances[e];
            i.type === t &&
              "function" == typeof i.forceReload &&
              i.forceReload();
          }
        },
      })),
      (theme.Modals = (function () {
        function t(t, e, i) {
          var n = {
            close: ".js-modal-close",
            open: ".js-modal-open-" + e,
            openClass: "modal--is-active",
            open_class: "open",
            closingClass: "modal--is-closing",
            bodyOpenClass: "modal-open",
            bodyOpenSolidClass: "modal-open--solid",
            bodyClosingClass: "modal-closing",
            closeOffContentClick: !0,
          };
          if (
            ((this.id = t),
            (this.modal = document.getElementById(t)),
            !this.modal)
          )
            return !1;
          (this.modalContent = this.modal.querySelector(".modal__inner")),
            (this.config = Object.assign(n, i)),
            (this.modalIsOpen = !1),
            (this.focusOnOpen = this.config.focusIdOnOpen
              ? document.getElementById(this.config.focusIdOnOpen)
              : this.modal),
            (this.isSolid = this.config.solid),
            this.init();
        }
        return (
          (t.prototype.init = function () {
            document.querySelectorAll(this.config.open).forEach((t) => {
              t.setAttribute("aria-expanded", "false"),
                t.addEventListener("click", this.open.bind(this));
            }),
              this.modal.querySelectorAll(this.config.close).forEach((t) => {
                t.addEventListener("click", this.close.bind(this));
              }),
              document.addEventListener(
                "drawerOpen",
                function () {
                  this.close();
                }.bind(this)
              );
          }),
          (t.prototype.open = function (t) {
            var e = !1;
            if (!this.modalIsOpen) {
              t ? t.preventDefault() : (e = !0),
                t &&
                  t.stopPropagation &&
                  (t.stopPropagation(),
                  (this.activeSource = t.currentTarget.setAttribute(
                    "aria-expanded",
                    "true"
                  ))),
                this.modalIsOpen && !e && this.close(),
                this.modal.classList.add(this.config.openClass);
              var closeButton,
                i = this,
                modalToFocus = this.modal;
              this.modal.querySelector("#modal-container") &&
                (modalToFocus = this.modal.querySelector("#modal-container")),
                this.modal.querySelector(".js-modal-close") &&
                  (closeButton = this.modal.querySelector(".js-modal-close")),
                setTimeout(function () {
                  i.modal.classList.add(i.config.open_class);
                }, 50),
                document.documentElement.classList.add(
                  this.config.bodyOpenClass
                ),
                this.isSolid &&
                  document.documentElement.classList.add(
                    this.config.bodyOpenSolidClass
                  ),
                (this.modalIsOpen = !0),
                setTimeout(function () {
                  trapFocus(modalToFocus, closeButton);
                }, 800),
                document.dispatchEvent(new CustomEvent("modalOpen")),
                document.dispatchEvent(new CustomEvent("modalOpen." + this.id)),
                this.bindEvents();
            }
          }),
          (t.prototype.close = function (t) {
            if (this.modalIsOpen) {
              if (t)
                if (t.target.closest(".js-modal-close"));
                else if (t.target.closest(".modal__inner")) return;
              document.activeElement.blur(),
                this.modal.classList.remove(this.config.openClass),
                this.modal.classList.add(this.config.closingClass);
              var e = this;
              setTimeout(function () {
                e.modal.classList.add(e.config.open_class);
              }, 50),
                document.documentElement.classList.remove(
                  this.config.bodyOpenClass
                ),
                document.documentElement.classList.add(
                  this.config.bodyClosingClass
                ),
                window.setTimeout(
                  function () {
                    document.documentElement.classList.remove(
                      this.config.bodyClosingClass
                    ),
                      this.modal.classList.remove(this.config.closingClass),
                      this.activeSource &&
                        this.activeSource.getAttribute("aria-expanded") &&
                        this.activeSource
                          .setAttribute("aria-expanded", "false")
                          .focus();
                  }.bind(this),
                  500
                ),
                this.isSolid &&
                  document.documentElement.classList.remove(
                    this.config.bodyOpenSolidClass
                  ),
                (this.modalIsOpen = !1),
                removeTrapFocus(
                  document.querySelector(".newsletter_btn_wrapper > a")
                ),
                document.dispatchEvent(
                  new CustomEvent("modalClose." + this.id)
                ),
                this.unbindEvents();
            }
          }),
          (t.prototype.bindEvents = function () {
            window.on(
              "keyup.modal",
              function (t) {
                27 === t.keyCode && this.close();
              }.bind(this)
            ),
              this.config.closeOffContentClick &&
                this.modal.on("click.modal", this.close.bind(this));
          }),
          (t.prototype.unbindEvents = function () {
            document.documentElement.off(".modal"),
              this.config.closeOffContentClick && this.modal.off(".modal");
          }),
          t
        );
      })()),
      (theme.NewsletterPopup = (function () {
        function t(t) {
          if (
            ((this.container = t),
            null == document.querySelector(".newsletter_right_btn"))
          ) {
            var i = this.container.getAttribute("data-section-id");
            (this.cookieName = "newsletter-" + i),
              t &&
                "/challenge" !== window.location.pathname &&
                ((this.data = {
                  secondsBeforeShow: t.dataset.delaySeconds,
                  daysBeforeReappear: t.dataset.delayDays,
                  cookie: Cookies.get(this.cookieName),
                  testMode: t.dataset.testMode,
                }),
                (this.modal = new theme.Modals(
                  "NewsletterPopup-" + i,
                  "newsletter-popup-modal"
                )),
                (this.modalElem = document.getElementById(
                  "NewsletterPopup-" + i
                )),
                (t.querySelector(".errors") ||
                  t.querySelector(".note--success")) &&
                  this.modal.open(),
                t.querySelector(".note--success")
                  ? this.closePopup(!0)
                  : (document.addEventListener(
                      "modalClose." + t.id,
                      this.closePopup.bind(this)
                    ),
                    (this.data.cookie && "true" !== this.data.testMode) ||
                      this.initPopupDelay()));
          } else {
            var e = this.container.getAttribute("data-section-id"),
              c = this;
            document
              .querySelector(".newsletter_right_btn")
              .addEventListener("click", function () {
                t &&
                  "/challenge" !== window.location.pathname &&
                  ((c.modal = new theme.Modals(
                    "NewsletterPopup-" + e,
                    "newsletter-popup-modal"
                  )),
                  c.initPopupDelay());
              });
          }
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            initPopupDelay: function () {
              if (null == document.querySelector(".newsletter_right_btn")) {
                if (!Shopify || !Shopify.designMode)
                  if (
                    this.modalElem.querySelector(
                      ".newsletter-form__message--success"
                    )
                  ) {
                    if (
                      window.localStorage.getItem("newsletter-popup_submitted")
                    )
                      return (
                        this.modal.open(),
                        void window.localStorage.removeItem(
                          "newsletter-popup_submitted"
                        )
                      );
                  } else
                    setTimeout(
                      function () {
                        this.modal.open(),
                          document
                            .querySelector(
                              '[data-section-type="newsletter-popup"] form'
                            )
                            .addEventListener("submit", function () {
                              window.localStorage.setItem(
                                "newsletter-popup_submitted",
                                !0
                              );
                            });
                      }.bind(this),
                      1e3 * this.data.secondsBeforeShow
                    );
              } else (Shopify && Shopify.designMode) || this.modal.open();
            },
            closePopup: function (t) {
              if (null == document.querySelector(".newsletter_right_btn"))
                if ("true" !== this.data.testMode) {
                  var i = parseInt(this.data.daysBeforeReappear);
                  Cookies.set(this.cookieName, "opened", {
                    path: "/",
                    expires: i,
                  });
                } else
                  Cookies.remove(this.cookieName, {
                    path: "/",
                  });
              else this.modal.close();
            },
            onLoad: function () {
              this.modal.open();
            },
            onSelect: function () {
              this.modal.open();
            },
            onDeselect: function () {
              this.modal.close();
            },
          })),
          t
        );
      })()),
      (theme.Slideshow = (function () {
        function t(t, e) {
          (this.el = t),
            (this.args = Object.assign({}, s, e)),
            (this.args.on = {
              ready: this.init.bind(this),
              change: this.slideChange.bind(this),
              settle: this.afterChange.bind(this),
            }),
            this.args.childNav &&
              ((this.childNavEls = this.args.childNav.querySelectorAll(
                n.thumb
              )),
              (this.childNavLinks = this.args.childNav.querySelectorAll(
                n.links
              )),
              (this.arrows = this.args.childNav.querySelectorAll(n.arrow)),
              this.childNavLinks.length && this.initChildNav()),
            this.args.avoidReflow &&
              (function i(t) {
                if (t.id) {
                  for (var e = t.firstChild; null != e && 3 == e.nodeType; )
                    e = e.nextSibling;
                  var i = document.createElement("style");
                  (i.innerHTML = `#${t.id} .flickity-viewport{height:${e.offsetHeight}px}`),
                    document.head.appendChild(i);
                }
              })(t),
            (this.slideshow = new Flickity(t, this.args)),
            window.on(
              "resize",
              theme.utils.debounce(
                300,
                function () {
                  this.resize();
                }.bind(this)
              )
            );
        }
        var e_animateOut = "animate-out",
          e_isPaused = "is-paused",
          e_isActive = "is-active",
          i_allSlides = ".slideshow__slide",
          i_currentSlide = ".is-selected:not(.dot)",
          n = {
            thumb: ".product__thumb-item:not(.hide)",
            links: ".product__thumb-item:not(.hide) .product__thumb",
            arrow: ".product__thumb-arrow",
          },
          s = {
            adaptiveHeight: !1,
            autoPlay: !1,
            avoidReflow: !1,
            childNav: null,
            childNavScroller: null,
            childVertical: !1,
            fade: !1,
            initialIndex: 0,
            pageDots: !1,
            pauseAutoPlayOnHover: !1,
            prevNextButtons: !1,
            rightToLeft: theme.config.rtl,
            setGallerySize: !0,
            wrapAround: !0,
          },
          focusableElements = [
            "a",
            "input",
            "select",
            "button",
            "iframe",
            'div[role="button"]',
            "model-viewer",
            "video",
            "lite-vimeo",
          ];
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function (t) {
              (this.currentSlide = this.el.querySelector(i_currentSlide)),
                this.args.callbacks &&
                  this.args.callbacks.onInit &&
                  "function" == typeof this.args.callbacks.onInit &&
                  this.args.callbacks.onInit(this.currentSlide),
                this.el.querySelectorAll(i_allSlides).forEach((slide) => {
                  focusableElements.forEach((focusableElement) => {
                    slide
                      .querySelectorAll(focusableElement)
                      .forEach((sliderLink) => {
                        sliderLink.tabIndex = -1;
                      });
                  });
                });
              var currentSlides = this.el.querySelectorAll(i_currentSlide);
              focusableElements.forEach((focusableElement) => {
                currentSlides.forEach(function (slide) {
                  slide
                    .querySelectorAll(focusableElement)
                    .forEach((sliderLink) => {
                      sliderLink.tabIndex = 0;
                    });
                });
              }),
                window.AOS && AOS.refresh();
            },
            slideChange: function (t) {
              if (
                (this.args.fade &&
                  this.currentSlide &&
                  (this.currentSlide.classList.add(e_animateOut),
                  this.currentSlide.addEventListener(
                    "transitionend",
                    function () {
                      this.currentSlide.classList.remove(e_animateOut);
                    }.bind(this)
                  )),
                this.args.childNav && this.childNavGoTo(t),
                this.slideshow)
              ) {
                focusableElements.forEach((focusableElement) => {
                  this.slideshow.cells.forEach((slide) => {
                    slide.element
                      .querySelectorAll(focusableElement)
                      .forEach((sliderLink) => {
                        sliderLink.tabIndex = -1;
                      });
                  });
                });
                var currentSlides = this.el.querySelectorAll(i_currentSlide);
                focusableElements.forEach((focusableElement) => {
                  currentSlides.forEach(function (slide) {
                    slide
                      .querySelectorAll(focusableElement)
                      .forEach((sliderLink) => {
                        sliderLink.tabIndex = 0;
                      });
                  });
                });
              }
              this.args.callbacks &&
                this.args.callbacks.onChange &&
                "function" == typeof this.args.callbacks.onChange &&
                this.args.callbacks.onChange(t),
                this.arrows &&
                  this.arrows.length &&
                  (this.arrows[0].classList.toggle("hide", 0 === t),
                  this.arrows[1].classList.toggle(
                    "hide",
                    t === this.childNavLinks.length - 1
                  ));
            },
            afterChange: function (t) {
              this.args.fade &&
                this.el.querySelectorAll(i_allSlides).forEach((t) => {
                  t.classList.remove(e_animateOut);
                }),
                this.args.childNav &&
                  this.childNavGoTo(this.slideshow.selectedIndex);
            },
            destroy: function () {
              this.args.childNav &&
                this.childNavLinks.length &&
                this.childNavLinks.forEach((t) => {
                  t.classList.remove(e_isActive);
                }),
                this.slideshow.destroy();
            },
            _togglePause: function () {
              this.pauseBtn.classList.contains(e_isPaused)
                ? (this.pauseBtn.classList.remove(e_isPaused),
                  this.slideshow.playPlayer())
                : (this.pauseBtn.classList.add(e_isPaused),
                  this.slideshow.pausePlayer());
            },
            resize: function () {
              this.slideshow.resize();
            },
            play: function () {
              this.slideshow.playPlayer();
            },
            pause: function () {
              this.slideshow.pausePlayer();
            },
            goToSlide: function (t) {
              this.slideshow.select(t);
            },
            setDraggable: function (t) {
              (this.slideshow.options.draggable = t),
                this.slideshow.updateDraggable();
            },
            initChildNav: function () {
              this.childNavLinks[this.args.initialIndex].classList.add(
                "is-active"
              ),
                this.childNavLinks.forEach((t, e) => {
                  t.setAttribute("data-index", e),
                    t.addEventListener(
                      "click",
                      function (t) {
                        t.preventDefault(),
                          this.goToSlide(this.getChildIndex(t.currentTarget));
                      }.bind(this)
                    ),
                    t.addEventListener(
                      "focus",
                      function (t) {
                        this.goToSlide(this.getChildIndex(t.currentTarget));
                      }.bind(this)
                    ),
                    t.addEventListener(
                      "keydown",
                      function (t) {
                        13 === t.keyCode &&
                          this.goToSlide(this.getChildIndex(t.currentTarget));
                      }.bind(this)
                    );
                }),
                this.arrows.length &&
                  this.arrows.forEach((t) => {
                    t.addEventListener("click", this.arrowClick.bind(this));
                  });
            },
            getChildIndex: function (t) {
              return parseInt(t.dataset.index);
            },
            childNavGoTo: function (t) {
              this.childNavLinks.forEach((t) => {
                t.classList.remove(e_isActive);
              });
              var i = this.childNavLinks[t];
              if ((i.classList.add(e_isActive), this.args.childNavScroller)) {
                if (this.args.childVertical) {
                  var n = i.offsetTop;
                  this.args.childNavScroller.scrollTop = n - 100;
                } else {
                  var s = i.offsetLeft;
                  this.args.childNavScroller.scrollLeft = s - 100;
                }
                $(window).innerWidth() < 901 &&
                  ((s = i.offsetLeft),
                  (this.args.childNavScroller.scrollLeft = s - 100));
              }
            },
            arrowClick: function (t) {
              t.currentTarget.classList.contains("product__thumb-arrow--prev")
                ? this.slideshow.previous()
                : this.slideshow.next();
            },
          })),
          t
        );
      })()),
      (theme.HeroSection = (function () {
        function t(t) {
          this.container = t;
          var e = t.getAttribute("data-section-id");
          if (
            ((this.slideshow = t.querySelector("#HeroSlider-" + e)),
            (this.namespace = "." + e),
            (this.initialIndex = 0),
            this.slideshow)
          ) {
            var i = t.parentElement;
            0 === [].indexOf.call(i.parentElement.children, i)
              ? this.init()
              : theme.initWhenVisible({
                  element: this.container,
                  callback: this.init.bind(this),
                });
          }
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var t = this.slideshow.querySelectorAll(".hero-slide");
              if (t.length > 1) {
                var e = {
                  prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
                  pageDots: this.slideshow.hasAttribute("data-dots"),
                  fade: !1,
                  lazyLoad: !0,
                  setGallerySize: !1,
                  initialIndex: this.initialIndex,
                  autoPlay:
                    "true" === this.slideshow.dataset.autoplay &&
                    parseInt(this.slideshow.dataset.speed),
                };
                this.flickity = new theme.Slideshow(this.slideshow, e);
              } else t[0].classList.add("is-selected");
            },
            setAsLoaded: function () {
              console.log(this.container);
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
            onBlockSelect: function (t) {
              var e = this.slideshow.querySelector(
                  ".hero__slide--" + t.detail.blockId
                ),
                i = parseInt(e.dataset.index);
              this.flickity && "function" == typeof this.flickity.pause
                ? (this.flickity.goToSlide(i), this.flickity.pause())
                : ((this.initialIndex = i),
                  setTimeout(
                    function () {
                      this.flickity &&
                        "function" == typeof this.flickity.pause &&
                        this.flickity.pause();
                    }.bind(this),
                    1e3
                  ));
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.args.autoPlay &&
                this.flickity.play();
            },
          })),
          t
        );
      })()),
      (theme.announcementBar = (function () {
        function n() {
          o && "function" == typeof o.destroy && o.destroy();
        }
        var s,
          o,
          a = {
            autoPlay: 5e3,
            avoidReflow: !0,
            adaptiveHeight: !0,
            prevNextButtons: !0,
            cellAlign: theme.config.rtl ? "right" : "left",
            fade: !0,
          };
        return {
          init: function t() {
            (s = document.getElementById("AnnouncementSlider")) &&
              (n(),
              1 !== s.dataset.blockCount && (o = new theme.Slideshow(s, a)));
          },
          onBlockSelect: function e(t) {
            var e = s.querySelector("#AnnouncementSlide-" + t),
              i = parseInt(e.dataset.index);
            o && "function" == typeof o.pause && (o.goToSlide(i), o.pause());
          },
          onBlockDeselect: function i() {
            o && "function" == typeof o.play && o.play();
          },
          unload: n,
        };
      })()),
      (theme.AnnouncementSection = (function () {
        function t(t) {
          (this.container = t),
            (this.sectionId = this.container.getAttribute("data-section-id")),
            this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              theme.announcementBar.init();
            },
            onBlockSelect: function (t) {
              theme.announcementBar.onBlockSelect(t.detail.blockId);
            },
            onBlockDeselect: function () {
              theme.announcementBar.onBlockDeselect();
            },
            onUnload: function () {
              theme.announcementBar.unload();
            },
          })),
          t
        );
      })()),
      (theme.FeaturedCollection = (function () {
        function t(t) {
          (this.container = t), this.timeout;
          var e = t.getAttribute("data-section-id");
          (this.slideshow = t.querySelector("#CollectionSlider-" + e)),
            (this.namespace = ".collectionSlider-" + e),
            this.slideshow &&
              theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
                threshold: 600,
              });
        }
        var e = {
          adaptiveHeight: !1,
          avoidReflow: !0,
          pageDots: !0,
          prevNextButtons: !0,
          groupCells: !0,
          lazyLoad: 4,
          cellAlign: "left",
        };
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              this.slideshow.dataset.count <= 3 && (e.wrapAround = !1),
                (this.flickity = new theme.Slideshow(this.slideshow, e));
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.pause();
            },
            onBlockSelect: function (t) {
              var e = this.slideshow.querySelector(
                  ".collection-slide--" + t.detail.blockId
                ),
                i = parseInt(e.dataset.index);
              clearTimeout(this.timeout),
                this.flickity &&
                  "function" == typeof this.flickity.pause &&
                  (this.flickity.goToSlide(i), this.flickity.pause());
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.pause();
            },
          })),
          t
        );
      })()),
      (theme.ReviewsSection = (function () {
        function t(t) {
          (this.container = t), this.timeout;
          var e = t.getAttribute("data-section-id");
          (this.slideshow = t.querySelector("#ReviewsSlider-" + e)),
            (this.namespace = ".reviewsSlider-" + e),
            this.slideshow &&
              theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
                threshold: 600,
              });
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              if (
                this.slideshow.querySelectorAll(".slideshow__slide").length > 1
              )
                var e = {
                  prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
                  pageDots: this.slideshow.hasAttribute("data-dots"),
                  groupCells: !0,
                  cellAlign: "left",
                  avoidReflow: !0,
                  wrapAround: !0,
                  autoPlay:
                    "true" === this.slideshow.dataset.autoplay &&
                    parseInt(this.slideshow.dataset.speed),
                };
              this.slideshow.dataset.count <= 3 && (e.wrapAround = !1),
                (this.flickity = new theme.Slideshow(this.slideshow, e)),
                this.slideshow.dataset.count > 2 &&
                  (this.timeout = setTimeout(
                    function () {
                      this.flickity.goToSlide(0);
                    }.bind(this),
                    1e3
                  ));
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
            onBlockSelect: function (t) {
              var e = this.slideshow.querySelector(
                  ".review-slide--" + t.detail.blockId
                ),
                i = parseInt(e.dataset.index);
              clearTimeout(this.timeout),
                this.flickity &&
                  "function" == typeof this.flickity.pause &&
                  (this.flickity.goToSlide(i), this.flickity.pause());
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
          })),
          t
        );
      })()),
      (theme.TestimonialSection = (function () {
        function t(t) {
          this.container = t;
          var e = t.getAttribute("data-section-id");
          if (
            ((this.slideshow = t.querySelector("#TestimonialSlider-" + e)),
            (this.namespace = "." + e),
            (this.initialIndex = 0),
            this.slideshow)
          ) {
            var i = t.parentElement;
            0 === [].indexOf.call(i.parentElement.children, i)
              ? this.init()
              : theme.initWhenVisible({
                  element: this.container,
                  callback: this.init.bind(this),
                });
          }
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var t = this.slideshow.querySelectorAll(".slideshow__slide");
              if (t.length > 1) {
                var e = {
                  prevNextButtons: !1,
                  pageDots: !0,
                  fade: !0,
                  lazyLoad: !0,
                  initialIndex: this.initialIndex,
                  autoPlay:
                    "true" === this.slideshow.dataset.autoplay &&
                    parseInt(this.slideshow.dataset.speed),
                };
                this.flickity = new theme.Slideshow(this.slideshow, e);
              } else t[0].classList.add("is-selected");
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
            onBlockSelect: function (t) {
              var e = this.slideshow.querySelector(
                  ".testimonial-slide--" + t.detail.blockId
                ),
                i = parseInt(e.dataset.index);
              this.flickity && "function" == typeof this.flickity.pause
                ? (this.flickity.goToSlide(i), this.flickity.pause())
                : ((this.initialIndex = i),
                  setTimeout(
                    function () {
                      this.flickity &&
                        "function" == typeof this.flickity.pause &&
                        this.flickity.pause();
                    }.bind(this),
                    1e3
                  ));
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.args.autoPlay &&
                this.flickity.play();
            },
          })),
          t
        );
      })()),
      (theme.CollectionListSection = (function () {
        function t(t) {
          this.container = t;
          var e = t.getAttribute("data-section-id");
          if (
            ((this.slideshowcollection = t.querySelector(
              "#CollectionSlider-" + e
            )),
            (this.namespace = "." + e),
            (this.initialIndex = 0),
            this.slideshowcollection)
          ) {
            var i = t.parentElement;
            0 === [].indexOf.call(i.parentElement.children, i)
              ? this.init()
              : theme.initWhenVisible({
                  element: this.container,
                  callback: this.init.bind(this),
                });
          }
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var t = this.slideshowcollection.querySelectorAll(
                ".collection--slider_inner"
              );
              if (t.length > 1) {
                this.flickity = new theme.Slideshow(this.slideshowcollection, {
                  avoidReflow: !0,
                  pageDots: !0,
                  prevNextButtons: !1,
                  groupCells: !1,
                  lazyLoad: !0,
                  cellAlign: "left",
                });
              } else t[0].classList.add("is-selected");
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
            onBlockSelect: function (t) {
              var e = this.slideshowcollection.querySelector(
                  ".card-slide--" + t.detail.blockId
                ),
                i = parseInt(e.dataset.index);
              this.flickity && "function" == typeof this.flickity.pause
                ? (this.flickity.goToSlide(i), this.flickity.pause())
                : ((this.initialIndex = i),
                  setTimeout(
                    function () {
                      this.flickity &&
                        "function" == typeof this.flickity.pause &&
                        this.flickity.pause();
                    }.bind(this),
                    1e3
                  ));
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.args.autoPlay &&
                this.flickity.play();
            },
          })),
          t
        );
      })()),
      (theme.EnhanceFeatureSection = (function () {
        function t(t) {
          this.container = t;
          var e = t.getAttribute("data-section-id");
          if (
            ((this.slideshowcollection = t.querySelector(
              "#EnhanceSlider-" + e
            )),
            (this.namespace = "." + e),
            (this.initialIndex = 0),
            this.slideshowcollection)
          ) {
            var i = t.parentElement;
            0 === [].indexOf.call(i.parentElement.children, i)
              ? this.init()
              : theme.initWhenVisible({
                  element: this.container,
                  callback: this.init.bind(this),
                });
          }
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var t = this.slideshowcollection.querySelectorAll(
                ".inner--enhance__cover"
              );
              if (t.length > 1) {
                this.flickity = new theme.Slideshow(this.slideshowcollection, {
                  avoidReflow: !0,
                  pageDots: !1,
                  prevNextButtons: !0,
                  groupCells: !1,
                  lazyLoad: !0,
                  cellAlign: "left",
                });
              } else t[0].classList.add("is-selected");
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
            onBlockSelect: function (t) {
              var e = this.slideshowcollection.querySelector(
                  ".enhance-feature-slide--" + t.detail.blockId
                ),
                i = parseInt(e.dataset.index);
              this.flickity && "function" == typeof this.flickity.pause
                ? (this.flickity.goToSlide(i), this.flickity.pause())
                : ((this.initialIndex = i),
                  setTimeout(
                    function () {
                      this.flickity &&
                        "function" == typeof this.flickity.pause &&
                        this.flickity.pause();
                    }.bind(this),
                    1e3
                  ));
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.args.autoPlay &&
                this.flickity.play();
            },
          })),
          t
        );
      })()),
      (theme.DontMissdealsSection = (function () {
        function t(t) {
          this.container = t;
          var e = t.getAttribute("data-section-id");
          if (
            ((this.slideshowdont = t.querySelector("#DontMiss-" + e)),
            (this.namespace = "." + e),
            (this.initialIndex = 0),
            this.slideshowdont)
          ) {
            var i = t.parentElement;
            0 === [].indexOf.call(i.parentElement.children, i)
              ? this.init()
              : theme.initWhenVisible({
                  element: this.container,
                  callback: this.init.bind(this),
                });
          }
          var get_timer = t.querySelectorAll(".timer--deals");
          for (i = 0; i < get_timer.length; i++) {
            var get_days = get_timer[i].getAttribute("data-days"),
              get_months = get_timer[i].getAttribute("data-months"),
              get_years = get_timer[i].getAttribute("data-years"),
              //countDown = new Date("Apr,24,2023 15:22:00").getTime();
              countDown = new Date(
                get_months + " " + get_days + "," + get_years + " 21:00:00"
              ).getTime();
            setInterval(function () {
              var now = new Date().getTime(),
                distance = countDown - now,
                get_hour_new = Math.floor((distance % 864e5) / 36e5);

              if (get_hour_new < 10) var print_hour = "0" + get_hour_new;
              else print_hour = get_hour_new;
              var get_minute_new = Math.floor((distance % 36e5) / 6e4);
              if (get_minute_new < 10) var print_minute = "0" + get_minute_new;
              else print_minute = get_minute_new;
              var get_second_new = Math.floor((distance % 6e4) / 1e3);
              if (get_second_new < 10) var print_second = "0" + get_second_new;
              else print_second = get_second_new;

              if (distance > 0) {
                (t.querySelector(".js-timer-days").innerText = Math.floor(
                  distance / 864e5
                )),
                  (t.querySelector(".js-timer-hours").innerText = print_hour),
                  (t.querySelector(".js-timer-minutes").innerText =
                    print_minute),
                  (t.querySelector(".js-timer-seconds").innerText =
                    print_second);
              } else {
                t.querySelector(".dont-miss__timer_countdown").style.display =
                  "none";
              }
            }, 1e3);
          }
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var t = this.slideshowdont.querySelectorAll(
                ".dont_miss__deals_inner"
              );
              if (t.length > 1) {
                this.flickity = new theme.Slideshow(this.slideshowdont, {
                  avoidReflow: !0,
                  pageDots: !0,
                  prevNextButtons: !1,
                  groupCells: !1,
                  lazyLoad: !0,
                  cellAlign: "left",
                });
              } else t[0].classList.add("is-selected");
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
            onBlockSelect: function (t) {
              var e = this.slideshowdont.querySelector(
                  ".dont-slide--" + t.detail.blockId
                ),
                i = parseInt(e.dataset.index);
              this.flickity && "function" == typeof this.flickity.pause
                ? (this.flickity.goToSlide(i), this.flickity.pause())
                : ((this.initialIndex = i),
                  setTimeout(
                    function () {
                      this.flickity &&
                        "function" == typeof this.flickity.pause &&
                        this.flickity.pause();
                    }.bind(this),
                    1e3
                  ));
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.args.autoPlay &&
                this.flickity.play();
            },
          })),
          t
        );
      })()),
      (theme.CollectionGridSection = (function () {
        function t(t) {
          this.container = t;
          var e = t.getAttribute("data-section-id");
          if (
            ((this.slideshowcollection = t.querySelector(
              "#CollectionGridSlider-" + e
            )),
            (this.namespace = "." + e),
            (this.initialIndex = 0),
            this.slideshowcollection)
          ) {
            var i = t.parentElement;
            0 === [].indexOf.call(i.parentElement.children, i)
              ? this.init()
              : theme.initWhenVisible({
                  element: this.container,
                  callback: this.init.bind(this),
                });
          }
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var get_w = document.querySelector("#MainContent").offsetWidth,
                t = this.slideshowcollection.querySelectorAll(
                  ".collection-grid:not(.more) .collection-grid__column"
                );
              if (t.length > 1) {
                if (get_w < 769) {
                  this.flickity = new theme.Slideshow(
                    this.slideshowcollection,
                    {
                      avoidReflow: !0,
                      pageDots: !0,
                      prevNextButtons: !0,
                      groupCells: !1,
                      lazyLoad: !0,
                      cellAlign: "left",
                    }
                  );
                }
              } else t[0].classList.add("is-selected");
              var current = this;
              window.addEventListener("resize", function (event) {
                document.querySelector("#MainContent").offsetWidth > 768
                  ? current.onUnload()
                  : current.init();
              });
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
            onBlockSelect: function (t) {
              var e = this.slideshowcollection.querySelector(
                  ".collectionGrid-slide--" + t.detail.blockId
                ),
                i = parseInt(e.dataset.index);
              this.flickity && "function" == typeof this.flickity.pause
                ? (this.flickity.goToSlide(i), this.flickity.pause())
                : ((this.initialIndex = i),
                  setTimeout(
                    function () {
                      this.flickity &&
                        "function" == typeof this.flickity.pause &&
                        this.flickity.pause();
                    }.bind(this),
                    1e3
                  ));
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.args.autoPlay &&
                this.flickity.play();
            },
          })),
          t
        );
      })()),
      (theme.LookbookSection = (function () {
        function t(t) {
          this.container = t;
          var e = t.getAttribute("data-section-id");
          if (
            ((this.slideshowcollection = t.querySelector(
              "#LookbookSlider-" + e
            )),
            (this.namespace = "." + e),
            (this.initialIndex = 0),
            this.slideshowcollection)
          ) {
            var i = t.parentElement;
            0 === [].indexOf.call(i.parentElement.children, i)
              ? this.init()
              : theme.initWhenVisible({
                  element: this.container,
                  callback: this.init.bind(this),
                });
          }
          var look_get = document.querySelectorAll(
            ".lookbook_upper__main .inner--lookbook__cover"
          );
          for (i = 0; i < look_get.length; i++)
            look_get[i].addEventListener("mouseover", function () {
              for (var j = 0; j < look_get.length; j++)
                look_get[j].classList.remove("big");
              this.classList.add("big");
            });
          var look_dot = document.querySelectorAll(".lookbook__dots");
          for (i = 0; i < look_dot.length; i++)
            fireClickOnEnterKeydown(look_dot[i]),
              look_dot[i].addEventListener("click", function () {
                !this.classList.contains("active_tooltip")
                  ? (this.classList.add("active_tooltip"),
                    this.nextElementSibling.classList.add("active_product"))
                  : (this.classList.remove("active_tooltip"),
                    this.nextElementSibling.classList.remove("active_product"));
              });
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var get_w = document.querySelector("#MainContent").offsetWidth,
                t = this.slideshowcollection.querySelectorAll(
                  ".inner--lookbook__cover"
                );
              if (t.length > 1) {
                if (get_w < 769) {
                  this.flickity = new theme.Slideshow(
                    this.slideshowcollection,
                    {
                      avoidReflow: !0,
                      pageDots: !0,
                      prevNextButtons: !0,
                      groupCells: !1,
                      lazyLoad: !0,
                      cellAlign: "left",
                    }
                  );
                }
              } else t[0].classList.add("is-selected");
              var current = this;
              window.addEventListener("resize", function (event) {
                document.querySelector("#MainContent").offsetWidth > 768
                  ? current.onUnload()
                  : current.init();
              });
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
            onBlockSelect: function (t) {
              var e = this.slideshowcollection.querySelector(
                  ".loookbook-slide--" + t.detail.blockId
                ),
                i = parseInt(e.dataset.index);
              this.flickity && "function" == typeof this.flickity.pause
                ? (this.flickity.goToSlide(i), this.flickity.pause())
                : ((this.initialIndex = i),
                  setTimeout(
                    function () {
                      this.flickity &&
                        "function" == typeof this.flickity.pause &&
                        this.flickity.pause();
                    }.bind(this),
                    1e3
                  ));
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.args.autoPlay &&
                this.flickity.play();
            },
          })),
          t
        );
      })()),
      (theme.ImageTextSection = (function () {
        function t(t) {
          (this.container = t), this.timeout;
          var e = t.getAttribute("data-section-id");
          (this.slideshow = t.querySelector("#ImageTextSlider-" + e)),
            (this.namespace = ".imageTextSlider-" + e),
            this.slideshow &&
              theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
                threshold: 600,
              });
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              if (
                this.slideshow.querySelectorAll(".slideshow__slide").length > 1
              )
                var e = {
                  prevNextButtons: !1,
                  pageDots: !0,
                  adaptiveHeight: !0,
                };
              (this.flickity = new theme.Slideshow(this.slideshow, e)),
                this.slideshow.dataset.count > 1 &&
                  (this.timeout = setTimeout(
                    function () {
                      this.flickity.goToSlide(0);
                    }.bind(this),
                    1e3
                  ));
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
            onBlockSelect: function (t) {
              var e = this.slideshow.querySelector(
                  ".image__slide--" + t.detail.blockId
                ),
                i = parseInt(e.dataset.index);
              clearTimeout(this.timeout),
                this.flickity &&
                  "function" == typeof this.flickity.pause &&
                  (this.flickity.goToSlide(i), this.flickity.pause());
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
          })),
          t
        );
      })()),
      (theme.ProductDetailsTabSection = (function () {
        function t(t) {
          (this.container = t), this.timeout;
          t.getAttribute("data-section-id");
          this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              for (
                var tab = document.querySelectorAll("#pro_tabs ul li"),
                  tabContent = document.querySelectorAll(
                    "#pro_tabs .common_des"
                  ),
                  i = 0;
                i < tab.length;
                i++
              )
                fireClickOnEnterKeydown(tab[i]),
                  tab[i].addEventListener("click", function (e) {
                    for (var i = 0; i < tab.length; i++)
                      tab[i].classList.remove("active");
                    for (i = 0; i < tabContent.length; i++)
                      tabContent[i].classList.remove("active_tab");
                    this.className += " active";
                    var matchingTab = this.getAttribute("data-tab");
                    document.getElementById(matchingTab).className +=
                      " active_tab";
                  });
              var accordion_details = document.querySelectorAll(
                  ".mobile_product_detail_tab summary"
                ),
                accordion_content = document.querySelectorAll(
                  ".mobile_product_detail_tab .details"
                );
              for (i = 0; i < accordion_details.length; i++)
                accordion_details[i].addEventListener("click", function (e) {
                  if (this.parentNode.classList.contains("open"))
                    this.parentNode.classList.remove("open");
                  else {
                    for (var i = 0; i < accordion_content.length; i++)
                      accordion_content[i].classList.remove("open");
                    this.parentNode.classList.add("open");
                  }
                });
            },
          })),
          t
        );
      })()),
      (theme.Product = (function () {
        function t(t) {
          this.container = t;
          var e = (this.sectionId = t.getAttribute("data-section-id")),
            i = (this.sectionId = t.getAttribute("data-block-id"));
          if ("" != this.sectionId) {
            (this.settings = {
              namespace: ".product-" + e,
              hasImages: !0,
              imageSetName: null,
              imageSetIndex: null,
              currentImageSet: null,
              imageSize: "620x",
              currentSlideIndex: 0,
            }),
              (this.selectors = {
                media: "[data-product-media-type-model]",
                closeMedia: ".product-single__close-media",
                photoThumbs: ".product__thumb-" + e,
                thumbSlider: "#ProductThumbs-" + e,
                thumbScroller: ".product__thumbs--scroller",
                mainSlider: "#ProductPhotos-" + i,
                imageContainer: "[data-product-images]",
                productImageMain: ".product-image-main--" + e,
              }),
              this.cacheElements(),
              (this.firstProductImage =
                this.cache.mainSlider.querySelector("img")),
              this.firstProductImage || (this.settings.hasImages = !1);
            var n = this.cache.mainSlider.querySelector("[data-set-name]");
            n && (this.settings.imageSetName = n.dataset.setName), this.init();
          }
        }
        var e_hidden = "hide",
          i_slide = ".product-main-slide",
          i_startingSlide = ".starting-slide";
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              this.inModal || (this.formSetup(), this.initProductSlider());
            },
            cacheElements: function () {
              this.cache = {
                form: this.container.querySelector(this.selectors.form),
                mainSlider: this.container.querySelector(
                  this.selectors.mainSlider
                ),
                thumbSlider: this.container.querySelector(
                  this.selectors.thumbSlider
                ),
                thumbScroller: this.container.querySelector(
                  this.selectors.thumbScroller
                ),
                productImageMain: this.container.querySelector(
                  this.selectors.productImageMain
                ),
              };
            },
            formSetup: function () {
              this.settings.imageSetName && this.updateImageSet();
            },
            imageSetArguments: function (t) {
              if (
                (t = t || (this.variants ? this.variants.currentVariant : null))
              ) {
                var e = (this.settings.currentImageSet = this.getImageSetName(
                    t[this.settings.imageSetIndex]
                  )),
                  i = this.settings.imageSetName + "_" + e;
                return (
                  (this.settings.currentSlideIndex = 0),
                  {
                    cellSelector: '[data-group="' + i + '"]',
                    imageSet: i,
                    initialIndex: this.settings.currentSlideIndex,
                  }
                );
              }
            },
            updateImageSet: function (t) {
              var e = t
                ? t.detail.variant
                : this.variants
                ? this.variants.currentVariant
                : null;
              if (e) {
                var i = this.getImageSetName(e[this.settings.imageSetIndex]);
                this.settings.currentImageSet !== i &&
                  this.initProductSlider(e);
              }
            },
            updateImageSetThumbs: function (t) {
              this.cache.thumbSlider
                .querySelectorAll(".product__thumb-item")
                .forEach((i) => {
                  i.classList.toggle(e_hidden, i.dataset.group !== t);
                });
            },
            getImageSetName: function (t) {
              return t
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-$/, "")
                .replace(/^-/, "");
            },
            initProductSlider: function (t) {
              if (this.cache.mainSlider.querySelectorAll(i_slide).length <= 1) {
                var e = this.cache.mainSlider.querySelector(i_slide);
                e && e.classList.add("is-selected");
              } else {
                if (
                  (this.flickity &&
                    "function" == typeof this.flickity.destroy &&
                    this.flickity.destroy(),
                  !t)
                ) {
                  var n = this.cache.mainSlider.querySelector(i_startingSlide);
                  this.settings.currentSlideIndex = this._slideIndex(n);
                }
                var s = {
                  adaptiveHeight: !0,
                  avoidReflow: !0,
                  lazyLoad: 1,
                  initialIndex: this.settings.currentSlideIndex,
                  childNav: this.cache.thumbSlider,
                  childNavScroller: this.cache.thumbScroller,
                  childVertical:
                    "beside" === this.cache.thumbSlider.dataset.position,
                  pageDots: !0,
                  prevNextButtons: !1,
                  wrapAround: !0,
                  cellAlign: "left",
                  callbacks: {
                    onChange: this.onSlideChange.bind(this),
                  },
                };

                if (this.settings.imageSetName) {
                  var o = this.imageSetArguments(t);
                  (s = Object.assign({}, s, o)),
                    this.updateImageSetThumbs(s.imageSet);
                }
                this.flickity = new theme.Slideshow(this.cache.mainSlider, s);
                var flkty = this.flickity.slideshow;

                document
                  .querySelectorAll(".shopify-model-viewer-ui__button.close")
                  .forEach((item) => {
                    item.addEventListener("click", function () {
                      const model = item
                        .closest(".product-image-main")
                        .querySelector("model-viewer");
                      flkty.options.draggable = true;
                      flkty.updateDraggable();
                      model.classList.add("disable");
                    });
                  });
                if (
                  document.querySelectorAll(
                    ".shopify-model-viewer-ui__controls-overlay button"
                  )
                ) {
                  document
                    .querySelectorAll(
                      ".shopify-model-viewer-ui__controls-overlay button"
                    )
                    .forEach((item) => {
                      item.addEventListener("click", function () {
                        const model = item
                          .closest(".product-image-main")
                          .querySelector("model-viewer");
                        if (model.classList.contains("disable")) {
                          model.classList.remove("disable");
                          flkty.options.draggable = false;
                          flkty.updateDraggable();
                        }
                      });
                    });
                }
              }
            },
            onSlideChange: function (t) {
              this.flickity &&
                (this.cache.mainSlider.querySelector(
                  '.product-main-slide[data-index="' +
                    this.settings.currentSlideIndex +
                    '"]'
                ),
                this.settings.imageSetName
                  ? this.cache.mainSlider.querySelectorAll(
                      ".flickity-slider .product-main-slide"
                    )[t]
                  : this.cache.mainSlider.querySelector(
                      '.product-main-slide[data-index="' + t + '"]'
                    ),
                this.flickity.slideshow.cells.forEach((t) => {
                  t.element.querySelectorAll("a").forEach((t) => {
                    t.tabIndex = -1;
                  });
                }),
                this.flickity.slideshow.cells[t].element
                  .querySelectorAll("a")
                  .forEach((t) => {
                    t.tabIndex = 0;
                  }),
                (this.settings.currentSlideIndex = t));
              if (this.cache.mainSlider.querySelectorAll("video")) {
                this.cache.mainSlider
                  .querySelectorAll("video")
                  .forEach((video) => {
                    if (
                      video
                        .closest(".product-main-slide")
                        .getAttribute("data-index") ===
                      this.settings.currentSlideIndex
                    ) {
                      return;
                    }
                    video.pause();
                    video
                      .closest(".product-single__media")
                      .classList.remove("playing");
                  });
              }
              if (document.querySelectorAll("iframe")) {
                document
                  .querySelectorAll("lite-youtube iframe")
                  .forEach((iframe) => {
                    if (
                      iframe
                        .closest(".product-main-slide")
                        .getAttribute("data-index") ===
                      this.settings.currentSlideIndex
                    ) {
                      return;
                    }
                    iframe.contentWindow.postMessage(
                      JSON.stringify({ event: "command", func: "stopVideo" }),
                      "*"
                    );
                    iframe
                      .closest(".product-single__media")
                      .classList.remove("playing");
                  });
                document.querySelectorAll(".js-vimeo").forEach((video) => {
                  if (
                    video
                      .closest(".product-main-slide")
                      .getAttribute("data-index") ===
                    this.settings.currentSlideIndex
                  ) {
                    return;
                  }
                  video.contentWindow.postMessage('{"method":"pause"}', "*");
                  video
                    .closest(".product-single__media")
                    .classList.remove("playing");
                });
              }

              //Autoplay video
              // if (
              //   this.cache.mainSlider.querySelector(
              //     '.product-main-slide[data-index="' +
              //       this.settings.currentSlideIndex +
              //       '"]'
              //   )
              // ) {
              //   if (
              //     this.cache.mainSlider
              //       .querySelector(
              //         '.product-main-slide[data-index="' +
              //           this.settings.currentSlideIndex +
              //           '"]'
              //       )
              //       .querySelector("video")
              //   ) {
              //     playMp4(this.cache.mainSlider
              //       .querySelector(
              //         '.product-main-slide[data-index="' +
              //           this.settings.currentSlideIndex +
              //           '"]'
              //       )
              //       .querySelector("video"));
              //     function playMp4(video, container) {
              //       if (video.classList.contains("lazyloaded")) {
              //         video.play();
              //         video
              //           .closest(".product-single__media")
              //           .classList.add("playing");
              //       } else {
              //         setTimeout(() => {
              //           playMp4(video, container);
              //         }, 200);
              //       }
              //     }
              //   }
              //   if (
              //     this.cache.mainSlider
              //       .querySelector(
              //         '.product-main-slide[data-index="' +
              //           this.settings.currentSlideIndex +
              //           '"]'
              //       )
              //       .querySelector("lite-youtube")
              //   ) {
              //     setTimeout(() => {
              //       this.cache.mainSlider
              //         .querySelector(
              //           '.product-main-slide[data-index="' +
              //             this.settings.currentSlideIndex +
              //             '"]'
              //         )
              //         .querySelector("lite-youtube")
              //         .click();
              //     }, 50);
              //   }
              //   if (
              //     this.cache.mainSlider
              //       .querySelector(
              //         '.product-main-slide[data-index="' +
              //           this.settings.currentSlideIndex +
              //           '"]'
              //       )
              //       .querySelector("lite-youtube iframe")
              //   ) {
              //     setTimeout(() => {
              //       this.cache.mainSlider
              //         .querySelector(
              //           '.product-main-slide[data-index="' +
              //             this.settings.currentSlideIndex +
              //             '"]'
              //         )
              //         .querySelector("lite-youtube iframe")
              //         .contentWindow.postMessage(
              //           JSON.stringify({ event: "command", func: "playVideo" }),
              //           "*"
              //         );
              //       this.cache.mainSlider
              //         .querySelector(
              //           '.product-main-slide[data-index="' +
              //             this.settings.currentSlideIndex +
              //             '"]'
              //         )
              //         .querySelector(".product-single__media")
              //         .classList.add("playing");
              //     }, 50);
              //   }
              //   if (
              //     this.cache.mainSlider
              //       .querySelector(
              //         '.product-main-slide[data-index="' +
              //           this.settings.currentSlideIndex +
              //           '"]'
              //       )
              //       .querySelector(".js-vimeo")
              //   ) {
              //     setTimeout(() => {
              //       this.cache.mainSlider
              //         .querySelector(
              //           '.product-main-slide[data-index="' +
              //             this.settings.currentSlideIndex +
              //             '"]'
              //         )
              //         .querySelector(".js-vimeo")
              //         .contentWindow.postMessage('{"method":"play"}', "*");
              //       this.cache.mainSlider
              //         .querySelector(
              //           '.product-main-slide[data-index="' +
              //             this.settings.currentSlideIndex +
              //             '"]'
              //         )
              //         .querySelector(".product-single__media")
              //         .classList.add("playing");
              //     }, 50);
              //   }
              // }
            },
            _slideIndex: function (t) {
              return t.getAttribute("data-index");
            },
            mediaLoaded: function (t) {
              this.container
                .querySelectorAll(this.selectors.closeMedia)
                .forEach((t) => {
                  t.classList.remove(e_hidden);
                }),
                this.flickity && this.flickity.setDraggable(!1);
            },
            mediaUnloaded: function (t) {
              this.container
                .querySelectorAll(this.selectors.closeMedia)
                .forEach((t) => {
                  t.classList.add(e_hidden);
                }),
                this.flickity && this.flickity.setDraggable(!0);
            },
            onUnload: function () {
              theme.ProductMedia.removeSectionModels(this.sectionId),
                this.flickity &&
                  "function" == typeof this.flickity.destroy &&
                  this.flickity.destroy();
            },
          })),
          t
        );
      })()),
      (theme.FeaturedProduct = (function () {
        function t(t) {
          (this.container = t), this.timeout;
          var e = t.getAttribute("data-section-id");
          (this.namespace = ".featuredProduct-" + e),
            this.slideshow &&
              theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
                threshold: 600,
              });
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              if (
                this.slideshow.querySelectorAll(".slideshow__slide").length >= 1
              )
                var e = {
                  prevNextButtons: !1,
                  draggable: !1,
                  pageDots: !0,
                };
              this.flickity = new theme.Slideshow(this.slideshow, e);
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.pause();
            },
            onBlockSelect: function (t) {
              var e = this.slideshow.querySelector(
                  ".featuredProduct__slide--" + t.detail.blockId
                ),
                i = parseInt(e.dataset.index);
              clearTimeout(this.timeout),
                this.flickity &&
                  "function" == typeof this.flickity.pause &&
                  (this.flickity.goToSlide(i), this.flickity.pause());
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.pause();
            },
          })),
          t
        );
      })()),
      (theme.brandlist = (function () {
        function t() {
          for (
            var var_click = document.querySelectorAll(".brand-svg-inner"),
              i = 0;
            i < var_click.length;
            i++
          )
            var_click[i].addEventListener("click", function () {
              for (
                var quote = this.dataset.quoteIndex,
                  child_list = document.querySelector(".brand-list").children,
                  j = 0;
                j < child_list.length;
                j++
              )
                child_list[j].classList.remove("active_quote");
              document.querySelector("." + quote).classList.add("active_quote");
              for (
                child_list = document.querySelector(".brand-svg").children,
                  j = 0;
                j < child_list.length;
                j++
              )
                child_list[j].classList.remove("active_svg");
              this.classList.add("active_svg");
            });
        }
        return {
          init: t,
          onBlockSelect: t,
          onBlockDeselect: t,
          unload: t,
        };
      })()),
      (theme.BrandListSection = (function () {
        function t(t) {
          (this.container = t),
            (this.sectionId = this.container.getAttribute("data-section-id")),
            this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              theme.brandlist.init();
            },
            onBlockSelect: function (t) {
              theme.brandlist.onBlockSelect();
            },
            onBlockDeselect: function () {
              theme.brandlist.onBlockDeselect();
            },
            onUnload: function () {
              theme.brandlist.unload();
            },
          })),
          t
        );
      })()),
      (theme.CollageTextSection = (function () {
        function t(t) {
          this.container = t;
          var e = t.getAttribute("data-section-id");
          if (
            ((this.slideshowcollection = t.querySelector(
              "#mobile_collage_images_slider-" + e
            )),
            (this.namespace = "." + e),
            (this.initialIndex = 0),
            this.slideshowcollection)
          ) {
            var i = t.parentElement;
            0 === [].indexOf.call(i.parentElement.children, i)
              ? this.init()
              : theme.initWhenVisible({
                  element: this.container,
                  callback: this.init.bind(this),
                });
          }
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var t = this.slideshowcollection.querySelectorAll(
                ".collage_img_wrapper"
              );
              if (t.length > 1) {
                this.flickity = new theme.Slideshow(this.slideshowcollection, {
                  avoidReflow: !0,
                  pageDots: !0,
                  prevNextButtons: !0,
                  groupCells: !1,
                  lazyLoad: !0,
                  cellAlign: "left",
                });
              } else t[0].classList.add("is-selected");
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
            onBlockSelect: function (t) {
              var e = this.slideshowcollection.querySelector(
                  ".collage_slide--" + e
                ),
                i = parseInt(e.dataset.index);
              this.flickity && "function" == typeof this.flickity.pause
                ? (this.flickity.goToSlide(i), this.flickity.pause())
                : ((this.initialIndex = i),
                  setTimeout(
                    function () {
                      this.flickity &&
                        "function" == typeof this.flickity.pause &&
                        this.flickity.pause();
                    }.bind(this),
                    1e3
                  ));
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.args.autoPlay &&
                this.flickity.play();
            },
          })),
          t
        );
      })()),
      (function DOMready(callback) {
        "loading" != document.readyState
          ? callback()
          : document.addEventListener("DOMContentLoaded", callback);
      })(function () {
        (theme.sections = new theme.Sections()),
          theme.sections.register("newsletter-popup", theme.NewsletterPopup),
          theme.sections.register("hero-section", theme.HeroSection),
          theme.sections.register(
            "announcement-section",
            theme.AnnouncementSection
          ),
          theme.sections.register(
            "featured-collection",
            theme.FeaturedCollection
          ),
          theme.sections.register("reviews-section", theme.ReviewsSection),
          theme.sections.register(
            "testimonial-section",
            theme.TestimonialSection
          ),
          theme.sections.register(
            "enhancedFeature-slider",
            theme.EnhanceFeatureSection
          ),
          theme.sections.register(
            "collection-list-slider",
            theme.CollectionListSection
          ),
          theme.sections.register(
            "collection-grid-slider",
            theme.CollectionGridSection
          ),
          theme.sections.register(
            "dont-miss-deals-slider",
            theme.DontMissdealsSection
          ),
          theme.sections.register("lookbook-slider", theme.LookbookSection),
          theme.sections.register(
            "image-with-text-section",
            theme.ImageTextSection
          ),
          theme.sections.register("product", theme.Product),
          theme.sections.register(
            "product-detaills-tab-section",
            theme.ProductDetailsTabSection
          ),
          theme.sections.register("featured-product", theme.FeaturedProduct),
          theme.sections.register("brand-section", theme.BrandListSection),
          theme.sections.register(
            "collage-with-text-section",
            theme.CollageTextSection
          ),
          document.dispatchEvent(new CustomEvent("page:loaded")),
          Shopify.designMode &&
            document.addEventListener("shopify:section:load", function (event) {
              if (null === document.querySelector(".product-slider-main"))
                return;
              setTimeout(function () {
                var sliders = document.querySelectorAll(
                  '.product-slider-main, [id^="ProductPhotos-"]'
                );
                sliders.length > 0 &&
                  sliders.forEach(function (slider) {
                    new Flickity(slider).resize();
                  });
              }, 300);
            });
      });
  })();
function fireClickOnEnterKeydown() {}

$(document).on("click", ".product-media__poster", function () {
  if (
    $(this).closest(".product-single__media").find("lite-youtube iframe")
      .length > 0
  ) {
    var video = $(this)
      .closest(".product-single__media")
      .find("lite-youtube iframe");
    video[0].contentWindow.postMessage(
      JSON.stringify({ event: "command", func: "stopVideo" }),
      "*"
    );
    video[0].closest(".product-single__media").classList.add("playing");
  }
  if (
    $(this).closest(".product-single__media").find("lite-youtube").length > 0
  ) {
    var video = $(this).closest(".product-single__media").find("lite-youtube");
    video[0].click();
    video[0].closest(".product-single__media").classList.add("playing");
  }
  if ($(this).closest(".product-single__media").find(".js-vimeo").length > 0) {
    var video = $(this).closest(".product-single__media").find(".js-vimeo");
    video[0].contentWindow.postMessage('{"method":"play"}', "*");
    video[0].closest(".product-single__media").classList.add("playing");
  }
  if ($(this).closest(".product-single__media").find("video").length > 0) {
    var video = $(this).closest(".product-single__media").find("video");
    console.log(video);
    video[0].play();
    video[0].closest(".product-single__media").classList.add("playing");
  }
});
